(function () {
  app.controller('UserCtrl', [
    "$scope", '$timeout',
    function ($scope, $timeout) {
      $scope.resendDisabled = true;
      $scope.countdown = 120;
      $scope.is_change_phone_number = false;
      $scope.tab_name = 'send_code';
      $scope.is_verified_otp = false;

      $scope.init = function () {};

      $scope.moveToNext = function ($event, index) {
        if ($scope.otp[index - 1] && index < 4) {
            document.getElementsByClassName("otp-input")[index].focus();
        }
      };

      $scope.startCountdown = function () {
        $scope.resendDisabled = true;
        let timer = setInterval(() => {
          $scope.countdown--;
          $scope.$apply();
          if ($scope.countdown <= 0) {
            clearInterval(timer);
            $scope.resendDisabled = false;
            $scope.$apply();
          }
        }, 1000);
      }

      $scope.sendCode = function () {
        if (!$scope.isValidPhone($scope.phone_number)) {
          toastr.error('Invalid phone number');
          return;
        }
        $.ajax({
          beforeSend: function(){
            // $(".loading").hide();
            // $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
            // $(".loading").attr('style', 'z-index: -1 !important');
          },
          url: $scope.send_code_path,
          dataType: "json",
          cache: false,
          type: "POST",
          data: {
            phone_number: $scope.phone_input.getNumber()
          },
          afterSend: function(){},
          success: function (rs) {
            $timeout(function () {
              if (rs.succeed) {
                $scope.tab_name = 'verify_code';
                toastr.success(rs.message);
                $scope.countdown = 120;
                $scope.startCountdown();
              } else {
                toastr.error(rs.message);
              }
            });
          },
          error: function (rs) {
            toastr.error(`${$scope.phone_input.getNumber()} is not a valid phone number.`);
          }
        });
      };

      $scope.verifyCode = function (is_profile = false) {
        if (!$scope.otp || !$scope.isValidOTP()) {
          toastr.error('Invalid OTP');
          return;
        }
        $.ajax({
          beforeSend: function(){
            // $(".loading").hide();
            // $(".loading").attr('style', 'background: rgba(0, 0, 0, 0)');
            // $(".loading").attr('style', 'z-index: -1 !important');
          },
          url: $scope.verify_path,
          dataType: "json",
          cache: false,
          type: "POST",
          data: {
            otp_code: $scope.otp.join(''),
            phone_number: $scope.phone_input.getNumber()
          },
          afterSend: function(){},
          success: function (rs) {
            $timeout(function () {
              if (rs.succeed) {
                $scope.is_verified_otp = true;
                if (is_profile) {
                  sessionStorage.setItem('showToastr', 'true');
                  sessionStorage.setItem('messageToastr', rs.message);
                  location.reload();
                } else {
                  toastr.success(rs.message);
                }
              } else {
                toastr.error(rs.message);
              }
            });
          }
        });
      };

      $scope.shipVerifyCode = function () {
        $scope.is_verified_otp = true;
        sessionStorage.setItem('shipVerifyCode', 'true');
      };

      $scope.isValidPhone = function(phone_number) {
        if(!phone_number) {return false;}
        var temp = $scope.phone_input.getNumber(),
            regex = /^\+?\d{1,3}\d{10,15}$/;
        
        return temp && regex.test(temp.trim());
      };

      $scope.isValidOTP = function() {
        return !$scope.otp || $scope.otp.filter(v => v !== '').length == 4;
      };
    }
  ]);

}).call(this);